"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var React = require("react");
var CLASS_NAME = 'i-icon';
var modifyChildren = function (child) {
    if (child && child.props) {
        var className = classNames(CLASS_NAME, child.props.className);
        var props = {
            className: className,
        };
        return React.cloneElement(child, props);
    }
};
var IconWrapper = function (_a) {
    var children = _a.children;
    return (React.createElement(React.Fragment, null, children &&
        React.Children.map(children, function (child) {
            return modifyChildren(child);
        })));
};
exports.IconWrapper = IconWrapper;
//# sourceMappingURL=IconWrapper.js.map